import { render, staticRenderFns } from "./Scores.vue?vue&type=template&id=7cb7b721&scoped=true"
import script from "./Scores.vue?vue&type=script&lang=js"
export * from "./Scores.vue?vue&type=script&lang=js"
import style0 from "./Scores.vue?vue&type=style&index=0&id=7cb7b721&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb7b721",
  null
  
)

export default component.exports